import { render, staticRenderFns } from "./denyButton.vue?vue&type=template&id=531576cc&"
import script from "./denyButton.vue?vue&type=script&lang=js&"
export * from "./denyButton.vue?vue&type=script&lang=js&"
import style0 from "./denyButton.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports